import $ from 'jquery';
import LP from '../0-lp';

LP.commentsDlg = {
    initButtons: function () {
        $('a[action="addComment"]').click(LP.commentsDlg.addComment);
        $('a[action="removeComment"]').click(LP.commentsDlg.removeComment);
    },

    initPreview: function () {
        var item = $('.item');
        item.mouseover(function () {
            $('.lp-comment-button', this).show();
        });
        item.mouseout(function () {
            $('.lp-comment-button', this).hide();
        });

        $('.lp-comment-button').click(LP.commentsDlg.open);
    },

    addComment: function () {
        var text = $('#lp-comment-text').val();
        if (!text) {
            return;
        }

        var url = $(this).attr('url');
        var params = $(this).attr('url_params');
        params += '&text=' + text;

        var onSuccess = function (json) {
            $('#lp-comments').html(json.html);
            LP.commentsDlg.initButtons();
            LP.commentsDlg.updateCounter($('.lp-dialog-tabs'));
        };
        window.Browser.send(url, params, onSuccess);
    },

    removeComment: function () {
        var ask = $('#lp-ask-comment-delete').html();
        var url = $(this).attr('url');
        var params = $(this).attr('url_params');

        LP.UI.warnConfirm(ask, function () {
            var onSuccess = function (json) {
                $('#lp-comments').html(json.html);
                LP.commentsDlg.updateCounter($('.lp-dialog-tabs'));
                LP.commentsDlg.initButtons();
            };
            window.Browser.send(url, params, onSuccess);
        });
    },

    askDiscard: function () {
        var discard = true;
        var commenttext = $('#lp-comment-text');
        if (commenttext.val() != '') {
            var askDiscard = $('#lp-ask-comment-discard').html();
            discard = confirm(askDiscard);
            if (discard) {
                commenttext.val('');
            }
        }
        return discard;
    },

    open: function () {
        var anchor = $(this);
        var name = 'lp-dlg-comments';
        var url = anchor.attr('url');
        var params = anchor.attr('url_params');

        var dialogParams = {
            id: name,
            title: anchor.attr('title'),
            modal: true,
            stack: true,
            autoOpen: true,
            closeOnEscape: true,
            draggable: true,
            resizable: true,
            open: function () {
                LP.commentsDlg.onOpen(name, url, params);
            },
            close: function () {
                LP.commentsDlg.updateCounter(anchor);
                LP.commentsDlg.onClose(name);
            },
            resize: function () {
                LP.commentsDlg.onResize(name);
            },
            beforeClose: function () {
                return LP.commentsDlg.askDiscard();
            },
            width: 640,
            height: 480,
            minWidth: 300,
            maxWidth: 1500,
            minHeight: 300,
            maxHeight: 1500,
            closeText: 'x'
        };

        var dialog = $('<div id="' + name + '"></div>');
        dialog.appendTo('body').dialog(dialogParams);
        $('.ui-dialog').css('border', '0');
        // dialog.parent().draggable();
    },

    onOpen: function (name, url, params) {
        var onSuccess = function (json) {
            $('#' + name).html(json.html);
            LP.commentsDlg.initButtons();
        };
        window.Browser.send(url, params, onSuccess);
        return true;
    },

    onClose: function (name) {
        var dialog = $('#' + name);
        try {
            dialog.dialog('destroy');
        } catch (er) { /* empty */
        }
        try {
            dialog.empty().remove();
        } catch (er) { /* empty */
        }
        return true;
    },

    onResize: function () {
    },

    updateCounter: function (anchor) {
        var comments = $('#lp-comments ul li');
        var numComments = comments.length - 1;
        $('.lp-comment-num', anchor).html(numComments);
    }
};

